"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _loading = require("@/mixins/loading/loading");

var _railway = require("@/mixins/railway/railway");

var _elementUi = require("element-ui");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRPlanHeaderComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRPlanHeaderComponent, _Mixins);

  var _super = _createSuper(MRPlanHeaderComponent);

  function MRPlanHeaderComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRPlanHeaderComponent);
    _this = _super.apply(this, arguments);
    _this.selectedPlanId = null;
    return _this;
  }

  (0, _createClass2.default)(MRPlanHeaderComponent, [{
    key: "isAssignToTruckDisabled",
    get: function get() {
      return this.$selectedOrders.length === 0 || this.selectedPlanId === null;
    }
  }, {
    key: "getAssignTruckDisabledDetails",
    get: function get() {
      var reason = {
        reason1: false
      };

      if (this.$selectedOrders.length === 0) {
        reason.reason1 = true;
      }

      return reason;
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "assignToTruck",
    value: function assignToTruck() {
      this.$emit('onManualAssignTruck', this.selectedPlanId);

      var p = _objectSpread(_objectSpread({}, this.$pagination), {}, {
        currentPage: 1
      });

      this.$setPagination(p);
    }
  }, {
    key: "refreshOrderTable",
    value: function () {
      var _refreshOrderTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newVal) {
        var p;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$setDateRange({
                  startDate: newVal[0] + ' 00:00:00',
                  endDate: newVal[1] + ' 23:59:59'
                });
                p = _objectSpread({}, this.$defaultPagination);
                p.pageSize = this.$pagination['pageSize'];
                this.$setPagination(p);
                this.$setSelectedOrders([]); // await this.$getUnassignedOrders();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshOrderTable(_x) {
        return _refreshOrderTable.apply(this, arguments);
      }

      return refreshOrderTable;
    }()
  }]);
  return MRPlanHeaderComponent;
}((0, _vuePropertyDecorator.Mixins)(_loading.LoadingMixin, _railway.RailwayMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], MRPlanHeaderComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'manual'
})], MRPlanHeaderComponent.prototype, "type", void 0);
MRPlanHeaderComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRPlanHeaderComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button,
    'el-tooltip': _elementUi.Tooltip,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-input': _elementUi.Input
  }
})], MRPlanHeaderComponent);
var _default = MRPlanHeaderComponent;
exports.default = _default;